module.exports = {
  apiDomain: 'https://api.taphoa.cz',
  // apiDomain: 'https://api-eshop.fourwals.com',
  // apiDomain: 'http://local.shopbox-backend.vn',
  dateTimeFormat: 'DD/MM/YYYY HH:mm:ss',
  dateFormat: 'YYYY/MM/DD',
  apiPrefix: '',
  dateTimeHHMMFormat: 'DD/MM/YYYY HH:mm',
  reCaptchaKey: '6LfTbtsUAAAAAO4w46Z75QUh7fsQPJ24CYYSCcPA'
}
